// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__16waQ","insightsList":"newBusinessInsightsMenu_insightsList__38JvI","active":"newBusinessInsightsMenu_active__QS1vd"};